import {property} from '@wonderlandengine/api/decorators.js';
import {SoundManagerInstance, Sounds} from '../../managers/soundmanager.js';
import {ActionBase} from './action-base.js';
import {Object3D} from '@wonderlandengine/api';
import {HowlerAudioSource} from '@wonderlandengine/components';
import {Particles} from '../particles.js';

/**
 * Action for the shower jump scare.
 * This action is triggerd when the user is in the bathroom in Scene1
 */
export class ActionShower extends ActionBase {
    static TypeName = 'action-shower';

    @property.object({required: true})
    waterParticle?: Object3D;
    @property.object({required: true})
    showerStartSoundObject!: Object3D;
    @property.object({required: true})
    showerRunningSoundObject!: Object3D;

    private isEnabled = false;
    private startShowerAudio!: HowlerAudioSource;
    private runningShowerAudio!: HowlerAudioSource;

    override start() {
        super.start();

        const tempAudioComponent =
            this.showerStartSoundObject.getComponent(HowlerAudioSource);
        if (!tempAudioComponent) {
            throw new Error(
                `player(${this.object.name}): showerStartSoundObject does not have a HowlerAudioSource component`
            );
        }
        this.startShowerAudio = tempAudioComponent;

        const tempAudioComponent2 =
            this.showerRunningSoundObject.getComponent(HowlerAudioSource);
        if (!tempAudioComponent2) {
            throw new Error(
                `player(${this.object.name}): showerRunningSoundObject does not have a HowlerAudioSource component`
            );
        }
        this.runningShowerAudio = tempAudioComponent2;
    }

    OnTrigger() {
        if (this.isEnabled) {
            return;
        }
        this.waterParticle!.getComponent(Particles)!.active = true;

        setTimeout(() => {
            this.startShowerAudio.play();
            this.runningShowerAudio.play();
        }, 30);

        setTimeout(() => SoundManagerInstance.playSound(Sounds.VOAiiie), 500);

        this.isEnabled = true;
    }
}
